import React from 'react';

const AlternativesContext = React.createContext({
  alternatives: {},
  setAlternatives: () => {},
});

export default AlternativesContext;
